<div class="redirection-container">
    <div *ngIf="isLoading" class="spinner-container">
      <div class="spinner"></div>
      <p>Creating initial access token...</p>
    </div>
</div>
<router-outlet />
